import React, {useState,useEffect} from 'react';

import Pop from '../pop/pop.jsx';
import BridgeGuides from './bridge-guides.jsx';
import {
    teeth as teethNumbers,
    getBridgedTeeth,
    getPositionsWithoutBridges,
    getToothPosition
} from '../common/teeth';

const TeethChart = (props)=> {

    const {
        teeth,
        setTeethState,
        setAppState,
        activeTeeth,
        setActiveTeeth,
        curType,
        setTeethStateRaw,
        bridgeState,
        setBridgeState,
        bridges,
        setBridges,
        bridgeProgress,
        setBridgeProgress,
        isBridgeEditing,
        setIsBridgeEditing,
        setBridge,
        overDentureType,
        popState,
        setPopState
    } = props;


    const [telescopicCap,setTelescopicCap] = useState(false);
    const [partialPositionTooth,setPartialPositionTooth] = useState(0);


    useEffect(()=>{
        if(!(bridgeProgress && bridgeProgress.type === "select-material")) return;
        const isBoth = bridgeProgress.position === "both";
        let teethToCrown = isBoth? [...teethNumbers.top, ...teethNumbers.bottom] : teethNumbers[bridgeProgress.position];
        const newTeeth = JSON.parse(JSON.stringify(teeth));
        teethToCrown.forEach(item => {
            const toothToChange = newTeeth.find(tooth =>
                tooth.id === item &&
                !["implant","abutment"].includes(tooth.state));
            if(toothToChange) toothToChange.state = "crown"
        })
        setTeethStateRaw(newTeeth);
    },[bridgeProgress])

    const isType = curType !== null;

    const getPanelClass = ()=>{
        const isInit = bridgeState === "init";
        if (isType && !(curType === 1 && isInit)) return "opened"
        else if([1,2].includes(curType) && isInit) return "bridge-init";
        else return "";
    }

    const hasActiveTooth = ()=> activeTeeth.length;

    const getPopType = ()=>{
        const types = {
            0:"telescopic",
            1:"bridge",
            2:"overdenture"
        }
        if(bridgeProgress === "can-add") return "add-only";
        else if(telescopicCap) return "telescopic-cap";
        else return types[curType];
    }


    const bridgeTeeth = (bridgedTeeth,noClean)=>{

        const inRange = getBridgedTeeth(bridgedTeeth || activeTeeth);
        inRange.forEach(item=> {
            if(
                teeth.find(tooth=>
                    tooth.id === item &&
                    !["implant","abutment"].includes(tooth.state) )
            ) setTeethState(item, "crown")
        });
        if(!noClean) setActiveTeeth([]);
    }


    const popClicked = (id,optionClicked)=>{
        const telescopicCapOptions = ["gold","non-precious"];
        const notAToothState = [ "complete-bridge", "add-all", "add-single", "add-more-teeth", "jaw-type","both","top","bottom", "complete", "choose-implants"];
        if(![...notAToothState,...telescopicCapOptions].includes(optionClicked) ) setTeethState(id,optionClicked);

        if([1,2].includes(curType)){
            if(telescopicCapOptions.includes(optionClicked)){
                setTeethStateRaw(prevState=> {
                        const newState = [...prevState];
                        newState.find(tooth=>tooth.id === id).telescopicCap = optionClicked;
                        return newState;
                    }
                );
                setPopState(false);
                if(!bridgeProgress) setBridgeProgress("can-add");
                setTelescopicCap(false);
            }
            if(optionClicked === "abutment"){
                setTelescopicCap(true);
                return;
            }
        }

        switch (curType) {
            case 0:
                setPopState(false);
                if(optionClicked !== "no-tooth") setAppState("choose-material");
                break;

            case 1:

                if(optionClicked === "add-more-teeth"){
                    setBridgeProgress("add-more");
                    setPopState(false);
                    setBridgeState(prevState => {
                        return {...prevState, status:null,type: "position"}
                    });
                    return
                }
                if(bridgeProgress === "add-more"){
                    setBridgeProgress("can-add");
                    setPopState(false);
                    return
                }
                if(bridgeProgress === null){
                    setBridgeProgress("can-add");
                    setPopState(false);
                }else if(bridgeProgress === "can-add"){
                    if(optionClicked === "add-all") {
                        setPopState(id);
                        setBridgeProgress("add-or-finalize");
                        setBridgeState({...bridgeState,type: "process", teeth: [activeTeeth]});
                        return
                    }else if(optionClicked === "add-single"){
                       setBridgeProgress("add-more");
                    }
                    }else if(bridgeProgress === "add-or-finalize"){
                        setPopState(false);
                        setBridgeProgress("finalize");
                        setBridgeState(prevState => {
                            return {...prevState, status:"add-or-finalize"}
                        });
                    }else if(bridgeProgress === "finalize"){
                        bridgeTeeth();
                        setBridgeState(prevState => {
                            return {...prevState, status:null}
                        });
                        if(isBridgeEditing) setBridge(bridgeState.material,"telescopic");
                        else setAppState("choose-material");
                    }else{
                        setPopState(id);
                    }
                break;
            case 2:
                const firstStage = ["both","top","bottom"];
                if(optionClicked === "implant"){
                    setPopState(false);
                    return;
                }
                if(firstStage.includes(optionClicked)){
                    setBridgeProgress({type:"select-teeth", position:optionClicked});
                }else if(optionClicked === "complete"){
                    setBridgeProgress(prevState=>{
                        return {...prevState, type:"select-material"}}
                    );
                    setAppState("choose-material");
                }else if(optionClicked === "choose-implants"){
                    setBridgeProgress({type:"choose-implants"});
                }else if(optionClicked === "complete-bridge"){
                    setBridgeProgress({type:"choose-material"});
                    setAppState("choose-material");
                }
                break;
            default:
                break;
        }
        }

    const toothClicked = (id)=>{
        if(!isType) return;
        if(curType === 0){
            if(hasActiveTooth()) return;
            toothActive(id);
        }else if(curType === 1) {
            if((hasActiveTooth() && !bridgeProgress)  || popState) return;
            if(teeth.find(item=>item.id  === id)?.state !== "healthy") return;
            if(bridgeState === "init")  setBridgeState({type: "position", teeth: id});
            else if(bridgeState === "other")  setBridgeState({type: "other-position", activeTeeth:id});
            toothActive(id,true);
        }else if(curType === 2){
            if(
               (( bridgeProgress.type === "select-teeth" &&
                (bridgeProgress.position === "both" ||
                    getToothPosition(id) === bridgeProgress.position
                )) ||
                bridgeProgress.type === "choose-implants" && teeth.find(tooth=>tooth.id === id).inPartialBridgeProgress) &&
                !popState
            ){
                toothActive(id,true);
                setPopState(id);
                //setTeethState(id,"implant");
            }else if(["partial-init","partial-range"].includes(bridgeProgress.type)){
                    const tooth =  teeth.find(tooth=>tooth.id === id);
                    if(!tooth || tooth.material || tooth.inPartialBridgeProgress) return;
                    setPartialPositionTooth(id);
                    toothActive(id,true);
                    setBridgeProgress({type:"partial-jaw"});
                    setTeethState(id,"crown");
                }else if(bridgeProgress.type === "partial-jaw"){
                    const tooth =  teeth.find(tooth=>tooth.id === id);
                    if(!tooth || tooth.material) return;
                    toothActive(id,true);
                    setBridgeProgress({type:"partial-range"});
                    setTeethState(id,"crown");
                    bridgeTeeth([...activeTeeth,id],true);
                    setTeethStateRaw(prevState => {
                        const newState = [...prevState];
                        const bridgedTeeth = getBridgedTeeth([...activeTeeth, id], true);
                        for (const tooth of bridgedTeeth) {
                            const toothState = newState.find(item => item.id === tooth);
                            toothState.inPartialBridgeProgress = true;
                        }
                        return newState;
                    });
                    //inPartialBridgeProgress
                    setBridges(prevState=>{
                        const newState = [...prevState];
                        const existingPartialBridge = newState.find(bridge=>bridge.bridgeProcess && bridge.bridgeType === "overDenture");
                        if(existingPartialBridge) existingPartialBridge.teeth = [...existingPartialBridge.teeth,[...activeTeeth,id]];
                        else{
                            newState.push({teeth:[[...activeTeeth,id]],bridgeProcess:true,bridgeType:"overDenture"});
                        }
                        setActiveTeeth([]);
                        return newState;
                    })
            }
        }
    }

    const toothActive = (id,add)=>{
            if(add) setActiveTeeth([...activeTeeth,id])
            else setActiveTeeth([id]);
            if(curType !== 2) setPopState(id);
    }

    const removeState = (id)=>{
        setTeethState(id,"healthy");
        setActiveTeeth([]);
        setAppState("choose-teeth");
    }

    const getWarning = ()=>{
        switch(curType){
            case 1:
                return <p className='teeth-information icon-warning'>{abraStr.selectTeethImplant}</p>
            default:
                return <p className='teeth-information icon-info'>{abraStr.selectTooth}</p>;
        }
    }

    const addToBridge = (bridgeIndex)=>{

        const bridgeToCut = bridges[bridgeIndex];
        setBridges(prevState=>{
            let newState = [...prevState];
            newState.splice(bridgeIndex,1);
            return newState;
        })
        console.log(bridgeToCut.teeth);
        setTeethStateRaw(prevState=> {
                const newState = [...prevState];
                const bridgeTeeth = getBridgedTeeth(bridgeToCut.teeth[0]);
                newState
                    .filter(tooth=>bridgeTeeth.includes(tooth.id) && tooth.state === "crown")
                    .forEach(tooth=>tooth.state = "healthy");
                return prevState;
            })
        setBridgeState({...bridgeToCut, type: "this-position",activeTeeth:bridgeToCut.teeth[0]});
        setActiveTeeth(...bridgeToCut.teeth);
        setBridgeProgress("can-add");
        setIsBridgeEditing(true);
    }


    const getOverDentureBridge = ()=>{
        if(bridgeProgress.type === "jaw-type"){
            const positionWithoutBridges = getPositionsWithoutBridges(bridges);
            if(positionWithoutBridges === "all") return {type:"init",  progress:"jaw-type"};
            else return {type:"position",position:positionWithoutBridges, progress:"jaw-type"};

        }else if(bridgeProgress.type === "select-teeth"){
            const type = bridgeProgress.position === "both"? "init" :  "position";
            return {type, progress:"select-teeth", position: bridgeProgress.position};

        }else if(bridgeProgress.type === "select-material"){
            const isBoth = bridgeProgress.position === "both";
            const type = isBoth? "init" :  "position";
            return {type, position: bridgeProgress.position};
        }else if(["partial-init"].includes(bridgeProgress.type)){
            return "other";
        }else if(bridgeProgress.type === "partial-jaw"){
         return {type:"other-position",activeTeeth};
        }else if(bridgeProgress.type === "partial-range"){
            return {type:"this-position",activeTeeth:[partialPositionTooth]};
        }
    }

    const getPositionPop = (position)=>{
        if(curType === 2 && [ "partial-range", "choose-implants"].includes(bridgeProgress?.type)){
            const BridgePosition =  getToothPosition(partialPositionTooth);
            if(BridgePosition === position){
                return(
                        <Pop
                            popType={bridgeProgress.type === "partial-range"? bridgeProgress.type : "complete"}
                            popClicked={popClicked}
                        />
                    )
            }
        }
    }


    const getBridgeGuides = ()=>{
            return(
                <>
                {curType === 1 &&
                <BridgeGuides
                    bridgeState={bridgeState}
                    popClicked={popClicked}
                    setTeethState={setTeethStateRaw}
                    teethState={teeth}
                    alreadySetBridges={bridges}
                    editable={true}
                    activeTeeth={activeTeeth}
                />
                }
                {curType === 2 && overDentureType  && !["choose-material", "choose-implants"].includes(bridgeProgress.type) &&
                <BridgeGuides
                    bridgeState={getOverDentureBridge()}
                    popClicked={popClicked}
                    setTeethState={setTeethStateRaw}
                    teethState={teeth}
                    alreadySetBridges={bridges}
                    editable={true}
                    activeTeeth={activeTeeth}
                    isOverDenture={true}
                />
                }
            <BridgeGuides
                bridgeState={{type:"set", bridges}}
                popClicked={popClicked}
                setTeethState={setTeethStateRaw}
                teethState={teeth}
                setBridges={setBridges}
                alreadySetBridges={bridges}
                editable={curType !== 0}
                addToBridge={addToBridge}
                activeTeeth={activeTeeth}
                isOverDenture={bridges.type === "overDenture"}
            />
            </>
            )
    }

    const getTeeth = (location, subLocation) => teeth
        .filter((item) => item.location === location && item.subLocation === subLocation)
        .map((item, index) => {
            const {id,state,faded, inBridge,inSetBridge,isTelescopicCrown} = item;
            const isMirror = subLocation === "left";
            const isTop = location === "top";
            const isWider = (index > 4 && subLocation === "right") || (index < 4 && subLocation === "left");
            const active = activeTeeth.includes(id);
            return (
                <div className={`tooth tooth-${id} ${faded? "faded": ""} ${active? "cur-tooth" : ""} state-${state} ${isMirror? "mirror" : ""} ${ isWider? "wider": ""} ${ inSetBridge? "in-set-bridge": ""} ${isTelescopicCrown? "isTelescopicCrown" : ""}` }
                    key={id}
                >
                    {popState === id &&
                    <Pop
                        popType={getPopType()}
                        popClicked={popClicked}
                        tooth={id}
                        activeTeeth={activeTeeth}
                        teethState={teeth}
                    />
                    }
                    {( !["healthy","crown"].includes(state)) && (curType === 0) && !inBridge &&
                        <div className='remove-state' data-a={inBridge}
                            onClick={()=> {removeState(id)}}
                        />
                    }
                    <div onClick={()=> {
                        toothClicked(id)
                    }}>
                        {isTop && <div className='icon'/>}
                        <span>{id}</span>
                        {!isTop && <div className='icon'/>}

                    </div>

                </div>
            )
        });

    return (
        <div className={`teeth-chart panel type-${curType}  ${getPanelClass()} ${(hasActiveTooth() && !bridgeProgress === null)? "active-tooth": ""}`}>
            <div className='head flex'>
                <div className='left'>
                    <h4>{abraStr.toothChart}</h4>
                    {getWarning()}
                </div>
                <div className='right'>
                    <div className='bridges-legends'>
                        {bridges.map((item,index)=>  !item.bridgeProcess &&
                            <div class={`bridge-legend ${item.bridgeType === "overDenture"? "orange" : "pink"}`}>
                                {`${abraStr.bridge} #${index+1}`}
                            </div>)
                        }
                    </div>
                    <a
                        className='on'
                        onClick={() => {
                            popClicked("all","healthy")
                        }}
                    >
                        {abraStr.healthyAll}</a>
                </div>
            </div>

            <div className='teeth-panel flex'>
                {getBridgeGuides()}
                {["left", "right"].map((subLocation) =>
                    <div className={`${subLocation}`}>
                        {["top", "bottom"].map((location) =>
                            <div className={`teeth-container ${location} flex`}>
                                {subLocation === "left" && getPositionPop(location)}
                                {getTeeth(location, subLocation)}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default TeethChart;
